<template>
  <div v-if="loading" class="full-loader">
    <div class="loader-wrapper">
      <img
        :src="gear"
        :class="['spinner', { 'stop-spin': handOnGear }]"
        alt="gear"
      />
      <img
        :src="hand"
        class="hand"
        :class="{ 'move-hand': handOnGear }"
        alt="hand"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      handOnGear: false,
      gear: '/s1.png',
      hand: '/s2.png',
    };
  },
  mounted() {
    // Move hand faster after 0.5s
    setTimeout(() => {
      this.handOnGear = true;
    }, 500);

    // End loader after 3s
    setTimeout(() => {
      this.loading = false;
    }, 3000);
  },
};
</script>

<style scoped>
.full-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader-wrapper {
  position: relative;
  width: 120px;  /* bigger gear container */
  height: 120px;
}

/* Gear spin */
.spinner {
  width: 120px;  /* bigger gear */
  height: 120px;
  animation: spin 1s linear infinite;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.stop-spin {
  animation-play-state: paused;
}

/* Hand image */
.hand {
  width: 95px;  /* bigger hand */
  height: 95px;
  position: absolute;
  left: -70px; /* start further left */
  top: 35px;   /* adjust to center vertically */
  z-index: 2;
  transition: all 0.5s ease-in-out; /* faster movement */
}
.move-hand {
  left: -30px; /* overlaps 50% of gear */
}

/* Gear spin keyframes */
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
